export enum RegionsEnum {
    eu = 'eu',
    am = 'am',
    ap = 'ap',
}
